import React, { Component } from "react";

class HeaderCheckbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: true
        }
    }

    //CHECKS (CABECERA)
    render() {
        return (<div className="checkbox-container">
            <input type="checkbox" id={this.props.title + this.props.index}
                checked={this.state.checked} value={this.props.index}
                onClick={(event) => this.setFilter(event)} />
            <label htmlFor={this.props.title + this.props.index}>{this.props.title}</label>
        </div>);
    }

    setFilter(event) {
        let currentCheck = event.target;
        let _checked = currentCheck.checked;
        this.setState({ checked: _checked });

        if (currentCheck.value == 1)
            this.props.setActivosCheckbox(_checked);

        if (currentCheck.value == 2)
            this.props.setBloqueadosCheckbox(_checked);

        if (currentCheck.value == 3)
            this.props.setEliminadosCheckbox(_checked);
    }
};

export default HeaderCheckbox